import axios from "axios";

function decryptC(text, shift = 3) {
  let result = "";

  const textLength = text.length;

  for (let i = 0; i < textLength; i++) {
    let char = text[i];

    if (/[a-zA-Z]/.test(char)) {
      let caseValue = /[A-Z]/.test(char) ? 65 : 97;

      result += String.fromCharCode(
        ((((char.charCodeAt(0) - shift - caseValue + 260) % 26) + 26) % 26) +
          caseValue
      );
    } else if (/\d/.test(char)) {
      result += String.fromCharCode(
        ((((char.charCodeAt(0) - shift - 48 + 260) % 10) + 10) % 10) + 48
      );
    } else {
      result += char;
    }
  }

  return result;
}
//
//
const handleClickToCall = async (dst, setIsProcessing) => {
  const token = localStorage.getItem("AccessToken");
  const compte = localStorage.getItem("compte");
  const poste = localStorage.getItem("poste");
  const BackendURL = window.BackendURLCmk;
  const switchAPI = window.switchAPI;

  const config = {
    headers: {
      Authorization: token,
    },
    params: {
      compte,
      poste,
      telephone: dst,
    },
  };

  try {
    await axios.get(
      `https://${BackendURL}:4444/${switchAPI}/Api/WS/ClickToCallPBXV3API`,
      config
    );
  } catch (e) {
    console.error("Error during API call click to call:", e);
  } finally {
    setIsProcessing(false);
  }
};

//
//
export { decryptC, handleClickToCall };
